// 2026-10-02 — shared gate for every "Réattribuer" render decision.
// Mirrors the server's assertReassignmentAllowed exactly: the flag blocks
// everyone, including super_admin, while disabled. Super_admin's special
// permission is controlling the flag (from Maintenance), not bypassing it.
export function canUseReassignment(role: string | undefined, flagEnabled: boolean | undefined): boolean {
  if (!role || !["manager", "admin", "super_admin"].includes(role)) return false;
  return Boolean(flagEnabled);
}
